import { forwardRef } from "react"
import { BaseIcon } from "@/components/icons/base-icon"
import type { BaseIconProps } from "@/components/icons/base-icon"

export type AlfredoIconProps = BaseIconProps

/**
 * Alfredo icon component
 *
 * Usage:
 * <AlfredoIcon size={24} className="text-gray-500" />
 */
export const AlfredoIcon = forwardRef<SVGSVGElement, AlfredoIconProps>(({ className, ...props }, ref) => {
  return (
    <BaseIcon ref={ref} className={className} viewBox="0 0 361 368" {...props}>
      <g transform="translate(9 9)" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit={2}>
        <path
          d="M171.5,346.966C-36.912,342.581 -56.686,45.98 138.44,5.222C288.545,-26.133 401.4,151.628 306.024,280.142C302.689,284.636 284.751,308.806 253.276,326.097C212.387,348.56 174.952,346.762 171.5,346.966ZM308.035,185.481C284.663,372.261 45.957,346.512 34.889,185.461C24.95,40.836 206.357,-26.152 286.152,96.724C309.589,132.815 308.25,178.171 308.035,185.481Z"
          fill="currentColor"
        />
        <path
          d="M146.283,78.331C146.361,78.135 147.495,52.968 170.503,52.973C195.76,52.979 194.166,77.186 196.577,79.412C196.631,79.508 197.283,82.573 201.576,83.406C202.648,85.154 202.659,85.233 204.619,85.382C205.718,86.965 205.428,87.149 206.579,87.406C206.941,87.682 207.302,87.958 207.664,88.233C208.77,89.12 208.571,89.248 209.596,89.396C209.992,89.97 210.388,90.543 210.784,91.117C213.005,93.259 212.58,93.822 215.578,94.404C215.943,94.676 216.307,94.948 216.672,95.22C217.766,96.115 217.553,96.26 218.611,96.379C219.754,97.988 219.468,98.152 220.583,98.402C220.942,98.68 221.302,98.958 221.662,99.236C222.038,99.535 222.413,99.835 222.789,100.134C223.763,101.071 223.543,101.217 224.589,101.391C224.657,101.511 225.35,104.608 229.58,105.401C230.607,107.133 230.603,107.257 232.648,107.353C233.779,109.035 233.469,109.181 234.579,109.416C235.896,110.737 235.863,110.538 237.481,111.53C237.913,113.057 237.932,113.01 239.58,113.403C239.944,113.674 240.307,113.945 240.671,114.217L240.779,115.133C243.027,116.24 242.958,116.291 243.584,116.394C245.109,117.174 269.226,109.523 278.13,126.694C290.378,150.312 267.436,160.693 264.687,161.937C263.117,162.647 263.126,190.36 264.686,191.067C267.449,192.319 291.229,203.091 277.771,226.653C267.071,245.386 243.413,234.852 241.745,234.89C239.585,236.198 239.723,236.015 237.806,237.898L237.576,238.592C236.988,239.012 236.4,239.433 235.813,239.854C233.603,241.139 233.738,240.944 231.801,242.899L231.581,243.599C230.513,243.8 230.73,243.956 229.825,244.858C227.281,245.839 227.198,245.539 225.782,247.87C225.462,248.204 225.142,248.537 224.821,248.871C222.583,250.123 222.671,249.982 220.795,251.888L220.588,252.608C217.531,253.121 217.975,253.743 215.792,255.89L215.584,256.606C213.012,257.061 213.86,257.819 213.825,257.854C212.055,258.559 212.132,258.425 210.797,259.893L210.582,260.601C208.041,261.097 208.845,261.82 208.814,261.851C207.046,262.596 207.166,262.418 205.805,263.903L205.57,264.586C204.982,265.004 204.393,265.422 203.804,265.84C201.24,266.829 201.483,266.863 199.8,268.888L199.587,269.607C198.49,269.814 198.703,269.979 197.809,270.853C196.063,271.619 196.396,271.758 195.642,273.57C194.978,275.533 194.993,275.368 194.978,275.533C194.743,278.124 192.87,298.711 172.491,299.018C145.705,299.421 150.291,277.021 143.325,271.785L143.279,270.786C140.165,268.864 140.265,268.761 139.401,268.621C138.097,266.049 138.246,265.711 135.381,265.613C134.307,264.061 134.593,263.869 133.426,263.588C133.063,263.312 132.7,263.037 132.337,262.761C131.265,261.887 131.471,261.743 130.405,261.602C129.316,260.058 129.599,259.864 128.428,259.586C128.065,259.309 127.703,259.033 127.34,258.756C126.279,257.883 126.484,257.741 125.418,257.589C124.298,256.035 124.578,255.853 123.429,255.584C123.066,255.309 122.703,255.034 122.339,254.759C121.266,253.878 121.472,253.739 120.417,253.59C120.019,253.017 119.621,252.443 119.222,251.87C117.892,249.862 117.906,249.713 115.398,249.602C114.277,248.044 114.559,247.863 113.414,247.603C113.051,247.328 112.689,247.052 112.327,246.776C111.2,245.851 111.408,245.73 110.412,245.595C109.291,244.045 109.58,243.851 108.409,243.611C107.403,241.881 107.412,241.74 105.331,241.665C104.261,240.022 104.573,239.828 103.411,239.608C102.367,237.836 102.355,237.747 100.374,237.625C99.276,236.019 99.58,235.824 98.413,235.605C96.825,234.397 95.859,234.75 95.643,234.829C56.381,249.179 45.473,203.736 76.283,190.303C78.467,181.66 77.481,166.239 76.289,162.693C73.427,161.457 48.3,150.607 62.225,126.344C73.02,107.534 97.26,118.088 97.316,118.085C99.14,117.279 98.967,117.388 100.171,116.069L100.414,115.396C101.563,115.135 101.28,114.952 102.397,113.388C106.023,110.324 106.182,110.739 106.426,110.422C107.512,110.234 107.294,110.073 108.233,109.167C108.526,109.001 110.168,108.071 111.429,106.426C112.496,106.214 112.276,106.06 113.172,105.143C114.962,104.406 114.848,104.588 116.184,103.085L116.418,102.4C117.485,102.166 117.278,102.018 118.174,101.134C119.702,100.452 119.56,100.533 120.314,99.177C122.215,97.431 122.286,97.588 122.419,97.413C125.489,96.848 125.038,96.223 127.182,94.082L127.409,93.389C128.464,93.183 128.254,93.038 129.19,92.139C130.588,91.478 130.514,91.631 131.327,90.224C131.693,89.952 132.059,89.68 132.424,89.408C133.612,89.142 133.319,88.937 134.383,87.382C136.886,87.283 136.873,87.134 138.227,85.138C138.623,84.562 139.018,83.986 139.414,83.41C142.88,80.273 143.193,80.749 143.438,80.432C144.538,80.216 144.333,80.052 145.226,79.196C145.578,78.908 145.93,78.619 146.283,78.331ZM148.814,91.873C151.233,89.483 155.835,97.305 160.683,99.128C170.225,102.715 167.714,105.702 164.216,115.273C163.702,116.679 146.395,119.185 146.983,140.491C147.159,146.837 152.014,148.887 144.216,155.131C143.636,155.595 143.791,155.52 143.188,156.072C142.527,156.404 142.169,155.39 139.406,158.401C138.15,160.035 136.493,160.964 136.199,161.129C135.088,161.67 135.194,161.612 134.417,162.396L134.186,163.073C133.289,163.517 133.263,162.951 132.417,163.37C132.313,163.421 132.417,163.37 131.358,164.36C130.41,165.405 129.58,166.255 129.423,166.417C128.241,167.584 126.19,169.697 123.561,166.432C122.927,166.035 122.293,165.637 121.658,165.24C121.298,164.962 120.938,164.684 120.577,164.406C120.258,164.063 119.939,163.72 119.621,163.377C118.273,162.107 118.127,162.505 116.601,161.38C115.958,160.984 115.315,160.588 114.672,160.191C114.495,160.063 113.581,159.4 112.608,158.389C111.713,157.553 111.831,157.624 110.672,157.185C110.307,156.925 109.941,156.665 109.576,156.405C108.53,155.307 108.636,155.415 107.563,154.401C100.182,150.464 109.841,144.916 106.448,132.518C104.975,127.139 106.39,127.231 110.578,123.584C111.651,122.517 111.519,122.65 112.573,121.578C113.87,119.981 115.511,119.021 115.803,118.851C116.9,118.327 116.797,118.382 117.566,117.571C121.594,113.495 121.693,113.836 126.554,110.584C127.226,109.914 127.898,109.244 128.57,108.574C128.752,108.352 128.798,108.449 131.503,106.505C132.617,105.569 132.52,105.663 133.575,104.579C134.875,102.983 136.503,102.038 136.794,101.869C137.918,101.333 137.813,101.377 138.581,100.584C139.853,98.957 141.491,98.017 141.783,97.849C142.906,97.321 142.8,97.363 143.573,96.578C143.709,96.404 143.776,96.563 145.674,94.787C146.598,94.045 146.655,94.459 147.616,93.622C148.015,93.039 148.414,92.456 148.814,91.873ZM122.58,187.586C126.014,183.288 127.153,184.301 131.431,187.584C132.502,188.718 132.401,188.611 133.443,189.591C134.304,190.048 139.832,192.987 143.426,196.581C144.063,196.978 144.7,197.375 145.337,197.772C145.515,197.904 146.432,198.586 147.447,199.559C148.065,199.932 148.683,200.305 149.3,200.678C149.436,201.725 139.747,226.261 160.681,236.138C163.801,237.61 162.521,238.564 163.276,246.503L163.249,251.326C156.218,255.252 156.396,255.24 151.159,261.099C150.932,260.998 149.565,260.391 148.504,259.493C147.816,259.088 143.976,256.824 140.556,253.44C139.5,252.348 139.583,252.432 138.517,251.475C136.24,250.173 136.366,250.234 134.572,248.422C134.24,248.088 133.908,247.753 133.575,247.419C132.938,247.026 132.301,246.633 131.665,246.24C131.489,246.105 130.579,245.406 129.578,244.416C129.258,244.073 128.937,243.73 128.616,243.386C127.757,242.572 127.88,242.637 126.686,242.177C126.506,242.051 125.579,241.403 124.571,240.424C124.243,240.085 123.915,239.747 123.587,239.409C122.95,239.012 122.312,238.614 121.674,238.217C121.496,238.086 120.575,237.409 119.568,236.427C119.24,236.088 118.913,235.748 118.585,235.409C117.944,235.02 117.303,234.63 116.662,234.241C116.485,234.107 115.573,233.413 114.577,232.419C114.257,232.074 113.936,231.73 113.615,231.386C112.736,230.559 112.856,230.627 111.683,230.183C111.504,230.056 110.577,229.404 109.562,228.433C109.242,228.089 108.921,227.745 108.601,227.401C107.732,226.574 107.852,226.641 106.676,226.21C103.818,224.13 108.765,215.191 106.448,207.518C105.109,203.084 103.929,202.335 107.557,199.585C108.593,198.577 108.477,198.695 109.565,197.582C109.935,197.326 110.305,197.07 110.676,196.814C112.108,195.613 112.252,196.034 113.574,194.578C113.752,194.353 113.801,194.451 116.5,192.5C117.61,191.55 117.518,191.635 118.578,190.597C118.946,190.339 119.314,190.08 119.683,189.822C121.121,188.608 121.24,189.028 122.58,187.586ZM195.427,94.579C195.752,94.92 196.077,95.261 196.403,95.602C197.044,95.997 197.685,96.393 198.326,96.788C198.505,96.919 199.424,97.593 200.428,98.579C201.065,98.971 201.702,99.363 202.339,99.755C203.429,100.585 204.273,101.418 204.431,101.573C205.51,102.686 205.409,102.583 206.494,103.509C208.099,104.455 208.075,104.253 209.422,105.584C209.749,105.923 210.076,106.263 210.403,106.603C211.045,106.996 211.687,107.39 212.33,107.783C212.508,107.914 213.427,108.588 214.424,109.58C214.742,109.928 215.059,110.275 215.376,110.623C216.234,111.433 216.111,111.368 217.313,111.828C217.681,112.086 218.049,112.344 218.418,112.602C219.104,113.246 219.791,113.891 220.477,114.535C221.074,114.875 224.839,117.016 227.423,119.582C228.097,120.25 228.771,120.919 229.444,121.587C231.097,122.465 231.081,122.267 232.438,123.568C233.536,124.657 233.433,124.556 234.506,125.493C237.511,127.961 229.645,135.254 234.55,148.479C235.738,151.681 235.717,151.902 233.343,154.242C232.706,154.636 232.069,155.03 231.432,155.425C229.615,157.658 229.314,157.162 227.192,159.065C226.599,159.376 226.142,158.554 223.421,161.403C222.778,161.764 222.134,162.125 221.491,162.486C220.393,163.446 220.503,163.342 219.418,164.397C218.769,164.75 218.12,165.103 217.471,165.455C217.044,166.006 216.616,166.556 216.189,167.106C215.874,167.409 215.56,167.711 215.245,168.013C214.38,167.754 213.516,167.495 212.651,167.236C211.523,166.373 198.735,156.595 198.565,156.43C197.531,155.303 197.609,155.388 196.563,154.402C187.551,149.634 201.296,138.794 190.949,125.176C183.037,114.761 177.757,119.139 177.744,114.448C177.72,105.398 173.484,102.92 181.655,98.817C189.15,95.054 189.375,88.641 195.427,94.579ZM216.425,185.583C217.064,185.975 217.702,186.367 218.341,186.759C218.517,186.894 219.425,187.591 220.435,188.571C222.216,190.475 222.286,190.106 224.419,191.601C225.589,192.76 225.415,192.587 226.489,193.517C227.012,193.826 226.924,193.521 227.338,193.765C227.432,193.821 227.338,193.765 228.423,194.595C229.52,195.668 229.412,195.564 230.494,196.509C231.013,196.821 230.928,196.514 231.338,196.76C231.432,196.817 231.338,196.76 232.413,197.604C233.1,198.249 233.786,198.894 234.473,199.54C238.244,201.793 230.518,209.426 233.536,220.488C234.438,223.795 235.116,224.148 232.449,226.423C231.384,227.422 231.489,227.314 230.433,228.428C230.251,228.65 230.203,228.55 227.481,230.471C226.373,231.446 226.526,231.294 225.43,232.425C222.368,236.186 217.953,238.73 217.217,239.154C216.096,239.683 216.202,239.64 215.43,240.425C215.182,240.74 215.047,240.288 211.405,243.398C210.416,244.412 209.586,245.261 209.428,245.423C209.246,245.645 209.199,245.547 206.493,247.49C205.412,248.417 205.514,248.313 204.43,249.425C203.147,251.039 201.487,251.979 201.193,252.145C200.077,252.68 200.183,252.628 199.43,253.425C191.628,261.324 190.264,260.031 189.596,259.398C179.664,249.987 178.422,252.188 177.584,251.393C165.707,240.132 179.45,240.623 190.553,228.545C199.607,218.696 191.445,200.878 192.674,199.719C193.314,199.348 193.955,198.976 194.595,198.604C194.924,198.269 195.253,197.934 195.582,197.6C196.224,197.238 196.867,196.876 197.509,196.514C198.576,195.579 198.471,195.683 199.575,194.594C200.227,194.246 200.879,193.898 201.531,193.549C202.216,192.901 202.902,192.253 203.587,191.605C207.803,189.209 213.427,181.587 216.425,185.583ZM154.579,162.583C163.793,157.194 164.627,165.232 176.535,162.693C182.475,161.426 183.193,159.359 187.438,163.569C188.073,163.963 188.708,164.358 189.343,164.752C189.52,164.887 190.433,165.583 191.437,166.57C192.072,166.964 192.707,167.359 193.342,167.754C193.836,168.131 198.648,171.8 199.431,172.575C200.451,173.668 200.363,173.578 201.438,174.576C202.461,175.96 202.562,176.163 201.386,177.394C201.065,177.731 200.743,178.068 200.421,178.405C199.776,178.763 199.131,179.12 198.486,179.478C197.407,180.395 197.512,180.289 196.414,181.394C195.766,181.746 195.117,182.098 194.469,182.45C193.786,183.101 193.103,183.752 192.42,184.403C192.06,184.681 191.701,184.959 191.342,185.236C190.699,185.625 190.056,186.014 189.413,186.402C189.277,186.577 189.208,186.407 187.339,188.235C186.699,188.627 186.059,189.019 185.419,189.411C181.725,194.074 173.564,188.47 165.465,190.31C159.024,191.773 158.238,193.14 153.59,188.402C152.948,188.008 152.306,187.614 151.665,187.22C151.3,186.951 150.934,186.682 150.569,186.413C149.473,185.285 149.583,185.399 148.562,184.404C148.055,184.132 144.333,182.136 142.569,180.422C141.93,180.03 141.291,179.638 140.653,179.245C137.74,177.025 135.41,176.137 137.839,174.925C140.896,173.4 140.608,173.143 143.507,171.51C144.6,170.586 144.493,170.692 145.584,169.601C146.858,168.884 146.502,168.58 147.782,167.851C148.901,167.316 148.795,167.36 149.565,166.571C149.746,166.348 149.795,166.45 152.508,164.512C153.64,163.557 153.546,163.645 154.579,162.583ZM270.104,136.554C265.998,169.59 232.759,144.432 247.618,129.619C252.071,125.18 258.752,125.06 262.325,126.859C268.228,129.831 267.649,130.553 270.104,136.554ZM184.104,136.554C179.998,169.589 146.758,144.432 161.618,129.619C166.071,125.18 172.752,125.06 176.325,126.859C182.228,129.831 181.649,130.553 184.104,136.554ZM96.104,136.554C91.998,169.59 58.759,144.432 73.618,129.619C78.071,125.18 84.752,125.06 88.325,126.859C94.228,129.831 93.649,130.554 96.104,136.554ZM96.103,211.555C92.022,244.463 58.844,219.729 73.627,204.642C75.639,202.589 82.358,198.859 88.326,201.859C92.859,204.137 95.705,210.644 96.103,211.555ZM270.103,211.555C266.022,244.463 232.844,219.729 247.627,204.642C249.639,202.589 256.358,198.859 262.326,201.859C266.859,204.137 269.705,210.644 270.103,211.555ZM184.103,79.445C171.581,108.594 144.477,73.069 165.659,64.846C181.529,58.686 183.872,77.578 184.103,79.445ZM184.103,211.555C180.022,244.463 146.844,219.729 161.627,204.642C175.077,190.915 183.349,209.831 184.103,211.555ZM169.493,262.618C170.501,262.599 171.508,262.581 172.516,262.562C174.114,262.271 175.331,261.112 181.233,266.647C179.386,268.446 179.532,268.3 179.386,268.446C177.624,270.215 179.999,269.18 182.384,268.604C194.181,285.904 156.421,299.789 157.892,272.555C158.391,263.311 168.274,262.694 169.493,262.618ZM234.579,168.597C234.981,168.391 247.282,157.147 251.136,162.9C251.228,163.037 251.44,188.685 251.159,189.357C247.802,197.381 229.458,179.187 227.184,177.85C226.476,177.433 225.414,177.745 224.809,177.189C224.434,176.843 225.177,176.003 224.801,175.657C225.386,175.294 225.97,174.931 226.555,174.568C227.224,174.245 227.894,173.923 228.563,173.6C229.614,172.624 229.512,172.73 230.589,171.609C231.246,171.271 231.903,170.933 232.56,170.595C233.609,169.615 233.507,169.721 234.579,168.597ZM89.712,162.692C94.124,160.709 94.264,161.215 98.422,163.595C99.506,164.692 99.399,164.587 100.487,165.52C103.686,167.286 104.005,166.593 106.422,169.585C107.061,169.981 107.7,170.378 108.339,170.775C108.699,171.049 109.06,171.324 109.42,171.598C110.516,172.703 110.412,172.598 111.491,173.515C112.14,173.87 112.789,174.225 113.438,174.58C114.101,174.914 114.765,175.248 115.428,175.582C116.741,177.541 115.563,177.447 113.521,178.533C112.373,179.452 112.469,179.367 111.416,180.4C111.056,180.678 110.695,180.957 110.335,181.235C109.693,181.624 109.052,182.013 108.41,182.402C108.08,182.739 107.75,183.077 107.42,183.414C106.11,184.724 106.144,184.52 104.5,185.499C103.428,186.431 103.601,186.256 102.439,187.433C101.095,188.732 101.127,188.529 99.484,189.475C98.412,190.429 98.518,190.324 97.431,191.414C94.073,193.665 89.879,190.38 89.712,190.308C89.756,176.366 89.781,176.518 89.712,162.692ZM201.438,174.576C201.657,174.601 211.27,176.296 202.238,177.217L201.386,177.394C202.562,176.163 202.461,175.96 201.438,174.576ZM181.233,266.647C181.351,266.785 181.291,266.796 182.384,268.604C179.999,269.18 177.624,270.215 179.386,268.446C179.532,268.3 179.386,268.446 181.233,266.647ZM220.435,188.571C223.125,189.088 222.929,189.279 224.419,191.601C222.286,190.106 222.216,190.475 220.435,188.571Z"
          fill="rgb(0,158,227)"
          fillOpacity={0.98}
        />
        <path
          d="M89.712,162.692C89.781,176.518 89.756,176.366 89.712,190.308C88.382,187.637 87.749,168.489 89.712,162.692Z"
          fill="rgb(0,137,188)"
          fillOpacity={0.14}
        />
        <path
          d="M76.289,162.693C77.481,166.239 78.467,181.66 76.283,190.303C76.243,176.327 76.219,176.561 76.289,162.693Z"
          fill="rgb(0,137,187)"
          fillOpacity={0.14}
        />
        <path
          d="M229.825,244.858L230.595,244.597C228.021,246.671 228.314,246.822 225.605,248.629L225.782,247.87C227.198,245.539 227.281,245.839 229.825,244.858Z"
          fill="rgb(0,152,209)"
          fillOpacity={0.14}
        />
        <path
          d="M201.438,174.576C201.657,174.601 211.27,176.296 202.238,177.217L201.386,177.394C202.562,176.163 202.461,175.96 201.438,174.576Z"
          fill="rgb(0,131,174)"
          fillOpacity={0.08}
        />
        <path
          d="M196.577,79.412C199.361,81.25 199.243,81.028 201.576,83.406C197.283,82.573 196.631,79.508 196.577,79.412Z"
          fill="rgb(0,136,194)"
          fillOpacity={0.17}
        />
        <path
          d="M224.589,101.391C227.315,103.268 227.302,103.089 229.58,105.401C225.35,104.608 224.657,101.511 224.589,101.391Z"
          fill="rgb(0,135,193)"
          fillOpacity={0.17}
        />
        <path
          d="M203.804,265.84L203.619,266.611C202.076,268.579 202.066,268.341 199.8,268.888C201.483,266.863 201.24,266.829 203.804,265.84Z"
          fill="rgb(0,172,220)"
          fillOpacity={0.13}
        />
        <path
          d="M224.821,248.871L224.623,249.624C222.887,251.366 223.045,251.319 220.795,251.888C222.671,249.982 222.583,250.123 224.821,248.871Z"
          fill="rgb(0,161,219)"
          fillOpacity={0.14}
        />
        <path
          d="M210.784,91.117L211.691,91.148C213.743,91.921 213.445,92.223 215.578,94.404C212.58,93.822 213.005,93.259 210.784,91.117Z"
          fill="rgb(0,146,199)"
          fillOpacity={0.16}
        />
        <path
          d="M220.588,252.608C218.452,254.722 218.586,254.645 215.792,255.89C217.975,253.743 217.531,253.121 220.588,252.608Z"
          fill="rgb(0,142,202)"
          fillOpacity={0.17}
        />
        <path
          d="M127.182,94.082C125.038,96.223 125.489,96.848 122.419,97.413C124.588,95.202 124.49,95.341 127.182,94.082Z"
          fill="rgb(0,142,201)"
          fillOpacity={0.18}
        />
        <path
          d="M135.381,265.613C138.246,265.711 138.097,266.049 139.401,268.621C137.294,267.206 137.026,267.707 135.381,265.613Z"
          fill="rgb(0,159,203)"
          fillOpacity={0.13}
        />
        <path
          d="M235.813,239.854L235.614,240.613C232.953,243.635 232.522,242.578 231.801,242.899C233.738,240.944 233.603,241.139 235.813,239.854Z"
          fill="rgb(0,161,218)"
          fillOpacity={0.17}
        />
        <path
          d="M115.398,249.602C117.906,249.713 117.892,249.862 119.222,251.87L119.407,252.617C117.228,251.161 117.245,251.506 115.398,249.602Z"
          fill="rgb(0,147,201)"
          fillOpacity={0.13}
        />
        <path
          d="M138.415,84.393L138.227,85.138C136.873,87.134 136.886,87.283 134.383,87.382C136.392,85.772 136.242,85.84 138.415,84.393Z"
          fill="rgb(0,142,200)"
          fillOpacity={0.14}
        />
        <path
          d="M241.745,234.89C240.465,238.13 238.491,237.558 237.806,237.898C239.723,236.015 239.585,236.198 241.745,234.89Z"
          fill="rgb(0,155,216)"
          fillOpacity={0.19}
        />
        <path
          d="M220.435,188.571C223.125,189.088 222.929,189.279 224.419,191.601C222.286,190.106 222.216,190.475 220.435,188.571Z"
          fill="rgb(0,136,181)"
          fillOpacity={0.19}
        />
        <path
          d="M139.401,268.621C140.265,268.761 140.165,268.864 143.279,270.786C142.644,270.735 142.01,270.683 141.376,270.632C141.22,270.469 140.399,269.607 139.401,268.621Z"
          fill="rgb(0,131,199)"
          fillOpacity={0.17}
        />
        <path
          d="M197.809,270.853L198.583,270.589C197.016,272.202 197.119,272.085 195.642,273.57C196.396,271.758 196.063,271.619 197.809,270.853Z"
          fill="rgb(0,120,181)"
          fillOpacity={0.11}
        />
        <path
          d="M143.188,156.072C141.502,157.859 141.707,158.089 139.406,158.401C142.169,155.39 142.527,156.404 143.188,156.072Z"
          fill="rgb(0,140,197)"
          fillOpacity={0.18}
        />
        <path
          d="M213.825,257.854L213.651,258.644C212.588,259.638 212.693,259.589 212.588,259.638C211.672,260.066 211.659,259.49 210.797,259.893C212.132,258.425 212.055,258.559 213.825,257.854Z"
          fill="rgb(0,158,221)"
          fillOpacity={0.18}
        />
        <path
          d="M116.184,103.085C114.848,104.588 114.962,104.406 113.172,105.143L113.331,104.336C114.413,103.358 114.308,103.409 114.413,103.358C115.261,102.948 115.281,103.522 116.184,103.085Z"
          fill="rgb(0,164,220)"
          fillOpacity={0.19}
        />
        <path
          d="M163.276,246.503C163.922,248.959 164.305,248.966 163.249,251.326L163.276,246.503Z"
          fill="rgb(0,124,173)"
          fillOpacity={0.18}
        />
        <path
          d="M208.814,261.851L208.647,262.643C207.582,263.629 207.686,263.578 207.582,263.629C206.677,264.076 206.651,263.486 205.805,263.903C207.166,262.418 207.046,262.596 208.814,261.851Z"
          fill="rgb(0,157,219)"
          fillOpacity={0.19}
        />
        <path
          d="M227.192,159.065C225.48,160.787 225.689,160.99 223.421,161.403C226.142,158.554 226.599,159.376 227.192,159.065Z"
          fill="rgb(0,140,188)"
          fillOpacity={0.2}
        />
        <path
          d="M134.186,163.073C132.765,164.599 132.891,164.405 131.178,165.13L131.358,164.36C132.417,163.37 132.313,163.421 132.417,163.37C133.263,162.951 133.289,163.517 134.186,163.073Z"
          fill="rgb(0,157,217)"
          fillOpacity={0.2}
        />
        <path
          d="M100.171,116.069C98.967,117.388 99.14,117.279 97.316,118.085C98.534,116.651 98.55,116.887 100.171,116.069Z"
          fill="rgb(0,163,215)"
          fillOpacity={0.2}
        />
        <path
          d="M113.574,194.578C112.252,196.034 112.108,195.613 110.676,196.814C111.694,195.079 111.548,194.934 113.574,194.578Z"
          fill="rgb(0,145,203)"
          fillOpacity={0.19}
        />
        <path
          d="M122.58,187.586C121.24,189.028 121.121,188.608 119.683,189.822C120.705,188.092 120.559,187.945 122.58,187.586Z"
          fill="rgb(0,152,195)"
          fillOpacity={0.19}
        />
        <path
          d="M120.314,99.177C119.56,100.533 119.702,100.452 118.174,101.134L118.369,100.37C119.293,99.509 119.411,99.926 120.314,99.177Z"
          fill="rgb(0,173,220)"
          fillOpacity={0.2}
        />
        <path
          d="M229.58,105.401C231.208,106.501 231.284,106.085 232.648,107.353C230.603,107.257 230.607,107.133 229.58,105.401Z"
          fill="rgb(0,131,172)"
          fillOpacity={0.15}
        />
        <path
          d="M105.331,241.665C107.412,241.74 107.403,241.881 108.409,243.611C106.756,242.477 106.709,242.914 105.331,241.665Z"
          fill="rgb(0,131,171)"
          fillOpacity={0.15}
        />
        <path
          d="M100.374,237.625C102.355,237.747 102.367,237.836 103.411,239.608C101.79,238.466 101.715,238.902 100.374,237.625Z"
          fill="rgb(0,133,172)"
          fillOpacity={0.15}
        />
        <path
          d="M201.576,83.406C203.19,84.521 203.276,84.095 204.619,85.382C202.659,85.233 202.648,85.154 201.576,83.406Z"
          fill="rgb(0,134,173)"
          fillOpacity={0.16}
        />
        <path
          d="M147.82,92.866L147.616,93.622C146.655,94.459 146.598,94.045 145.674,94.787C146.492,93.39 146.416,93.544 147.82,92.866Z"
          fill="rgb(0,145,225)"
          fillOpacity={0.21}
        />
        <path
          d="M116.601,161.38C118.127,162.505 118.273,162.107 119.621,163.377C118.992,163.308 118.364,163.238 117.736,163.168C117.358,162.572 116.979,161.976 116.601,161.38Z"
          fill="rgb(0,130,169)"
          fillOpacity={0.17}
        />
        <path
          d="M131.327,90.224C130.514,91.631 130.588,91.478 129.19,92.139L129.41,91.403C130.36,90.573 130.397,90.987 131.327,90.224Z"
          fill="rgb(0,143,216)"
          fillOpacity={0.2}
        />
        <path
          d="M214.424,109.58C214.717,109.63 214.498,109.564 217.259,110.816C216.631,110.751 216.003,110.687 215.376,110.623C215.059,110.275 214.742,109.928 214.424,109.58Z"
          fill="rgb(0,136,182)"
          fillOpacity={0.18}
        />
        <path
          d="M148.504,259.493C149.565,260.391 150.932,260.998 151.159,261.099C149.056,260.273 148.739,260.573 148.504,259.493Z"
          fill="rgb(0,105,155)"
          fillOpacity={0.13}
        />
        <path
          d="M126.76,243.164C127.378,243.238 127.997,243.312 128.616,243.386C128.937,243.73 129.258,244.073 129.578,244.416C129.164,244.345 129.202,244.312 126.76,243.164Z"
          fill="rgb(0,129,183)"
          fillOpacity={0.18}
        />
        <path
          d="M117.736,163.168C118.364,163.238 118.992,163.308 119.621,163.377C119.939,163.72 120.258,164.063 120.577,164.406C120.145,164.326 120.19,164.298 117.736,163.168Z"
          fill="rgb(0,124,189)"
          fillOpacity={0.2}
        />
        <path
          d="M240.779,115.133C241.387,115.22 241.994,115.306 242.601,115.392C242.929,115.726 243.256,116.06 243.584,116.394C242.958,116.291 243.027,116.24 240.779,115.133Z"
          fill="rgb(0,130,179)"
          fillOpacity={0.18}
        />
        <path
          d="M195.582,197.6C195.253,197.934 194.924,198.269 194.595,198.604C193.988,198.69 193.38,198.775 192.773,198.86C195.076,197.743 195.011,197.703 195.582,197.6Z"
          fill="rgb(0,116,188)"
          fillOpacity={0.19}
        />
        <path
          d="M199.431,172.575C201.119,172.915 201.177,172.985 201.438,174.576C200.363,173.578 200.451,173.668 199.431,172.575Z"
          fill="rgb(0,113,166)"
          fillOpacity={0.13}
        />
        <path
          d="M196.563,154.402C197.609,155.388 197.531,155.303 198.565,156.43C197.447,156.182 197.74,156.029 196.563,154.402Z"
          fill="rgb(0,107,176)"
          fillOpacity={0.14}
        />
        <path
          d="M169.493,262.618C171.089,262.095 170.904,262.1 172.516,262.562C171.508,262.581 170.501,262.599 169.493,262.618Z"
          fill="rgb(0,124,191)"
          fillOpacity={0.16}
        />
        <path
          d="M113.331,104.336L113.172,105.143C112.276,106.06 112.496,106.214 111.429,106.426C111.585,106.261 112.4,105.4 113.331,104.336Z"
          fill="rgb(0,118,160)"
          fillOpacity={0.13}
        />
        <path
          d="M230.589,171.609C229.512,172.73 229.614,172.624 228.563,173.6C228.845,172.021 228.902,171.952 230.589,171.609Z"
          fill="rgb(0,119,164)"
          fillOpacity={0.15}
        />
        <path
          d="M232.449,226.423C231.292,227.988 231.567,228.162 230.433,228.428C231.489,227.314 231.384,227.422 232.449,226.423Z"
          fill="rgb(0,120,160)"
          fillOpacity={0.15}
        />
        <path
          d="M148.562,184.404C149.583,185.399 149.473,185.285 150.569,186.413C149.409,186.16 149.697,185.977 148.562,184.404Z"
          fill="rgb(0,114,158)"
          fillOpacity={0.14}
        />
        <path
          d="M215.584,256.606C215.424,256.764 214.588,257.591 213.651,258.644L213.825,257.854C213.86,257.819 213.012,257.061 215.584,256.606Z"
          fill="rgb(0,110,162)"
          fillOpacity={0.13}
        />
        <path
          d="M109.565,197.582C108.477,198.695 108.593,198.577 107.557,199.585C108.664,198.046 108.379,197.846 109.565,197.582Z"
          fill="rgb(0,114,158)"
          fillOpacity={0.15}
        />
        <path
          d="M209.596,89.396C210.587,90.392 211.511,91.025 211.691,91.148L210.784,91.117C210.388,90.543 209.992,89.97 209.596,89.396Z"
          fill="rgb(0,106,156)"
          fillOpacity={0.15}
        />
        <path
          d="M210.582,260.601C210.423,260.76 209.591,261.594 208.647,262.643L208.814,261.851C208.845,261.82 208.041,261.097 210.582,260.601Z"
          fill="rgb(0,113,162)"
          fillOpacity={0.14}
        />
        <path
          d="M98.413,235.605C99.58,235.824 99.276,236.019 100.374,237.625C99.405,236.602 98.572,235.765 98.413,235.605Z"
          fill="rgb(0,118,164)"
          fillOpacity={0.13}
        />
        <path
          d="M103.411,239.608C104.573,239.828 104.261,240.022 105.331,241.665C104.393,240.608 103.568,239.769 103.411,239.608Z"
          fill="rgb(0,110,162)"
          fillOpacity={0.14}
        />
        <path
          d="M224.419,191.601C225.995,191.907 226.149,191.875 226.489,193.517C225.415,192.587 225.589,192.76 224.419,191.601Z"
          fill="rgb(0,121,164)"
          fillOpacity={0.14}
        />
        <path
          d="M107.563,154.401C108.636,155.415 108.53,155.307 109.576,156.405C107.904,156.038 107.849,155.972 107.563,154.401Z"
          fill="rgb(0,112,164)"
          fillOpacity={0.15}
        />
        <path
          d="M232.648,107.353C233.6,108.396 234.423,109.253 234.579,109.416C233.469,109.181 233.779,109.035 232.648,107.353Z"
          fill="rgb(0,116,163)"
          fillOpacity={0.14}
        />
        <path
          d="M128.57,108.574C127.898,109.244 127.226,109.914 126.554,110.584C127.791,108.942 127.502,108.825 128.57,108.574Z"
          fill="rgb(0,113,166)"
          fillOpacity={0.16}
        />
        <path
          d="M227.423,119.582C228.485,119.835 228.198,119.948 229.444,121.587C228.771,120.919 228.097,120.25 227.423,119.582Z"
          fill="rgb(0,115,164)"
          fillOpacity={0.16}
        />
        <path
          d="M234.579,168.597C233.507,169.721 233.609,169.615 232.56,170.595C233.786,168.971 233.497,168.848 234.579,168.597Z"
          fill="rgb(0,115,163)"
          fillOpacity={0.16}
        />
        <path
          d="M198.486,179.478C198.137,181.135 197.969,181.08 196.414,181.394C197.512,180.289 197.407,180.395 198.486,179.478Z"
          fill="rgb(0,119,165)"
          fillOpacity={0.15}
        />
        <path
          d="M232.413,197.604C234.086,197.957 234.123,197.886 234.473,199.54C233.786,198.894 233.1,198.249 232.413,197.604Z"
          fill="rgb(0,118,165)"
          fillOpacity={0.15}
        />
        <path
          d="M203.587,191.605C202.902,192.253 202.216,192.901 201.531,193.549C201.869,191.883 202.033,191.931 203.587,191.605Z"
          fill="rgb(0,117,164)"
          fillOpacity={0.15}
        />
        <path
          d="M131.431,187.584C132.507,187.845 132.221,187.966 133.443,189.591C132.401,188.611 132.502,188.718 131.431,187.584Z"
          fill="rgb(0,111,165)"
          fillOpacity={0.16}
        />
        <path
          d="M129.41,91.403L129.19,92.139C128.254,93.038 128.464,93.183 127.409,93.389C128.41,92.403 129.25,91.562 129.41,91.403Z"
          fill="rgb(0,117,163)"
          fillOpacity={0.14}
        />
        <path
          d="M206.493,247.49C206.123,249.096 206.11,249.053 204.43,249.425C205.514,248.313 205.412,248.417 206.493,247.49Z"
          fill="rgb(0,116,166)"
          fillOpacity={0.15}
        />
        <path
          d="M227.481,230.471C227.107,232.082 227.093,232.042 225.43,232.425C226.526,231.294 226.373,231.446 227.481,230.471Z"
          fill="rgb(0,116,165)"
          fillOpacity={0.15}
        />
        <path
          d="M194.469,182.45C194.125,184.101 193.974,184.065 192.42,184.403C193.103,183.752 193.786,183.101 194.469,182.45Z"
          fill="rgb(0,115,166)"
          fillOpacity={0.16}
        />
        <path
          d="M199.575,194.594C198.471,195.683 198.576,195.579 197.509,196.514C197.862,194.881 197.902,194.95 199.575,194.594Z"
          fill="rgb(0,112,164)"
          fillOpacity={0.15}
        />
        <path
          d="M108.409,243.611C109.58,243.851 109.291,244.045 110.412,245.595C110.253,245.435 109.414,244.594 108.409,243.611Z"
          fill="rgb(0,116,162)"
          fillOpacity={0.15}
        />
        <path
          d="M138.517,251.475C139.583,252.432 139.5,252.348 140.556,253.44C138.894,253.039 138.89,253.067 138.517,251.475Z"
          fill="rgb(0,112,165)"
          fillOpacity={0.15}
        />
        <path
          d="M228.423,194.595C230.082,194.953 230.125,194.881 230.494,196.509C229.412,195.564 229.52,195.668 228.423,194.595Z"
          fill="rgb(0,111,164)"
          fillOpacity={0.15}
        />
        <path
          d="M104.5,185.499C104.116,187.093 104.096,187.046 102.439,187.433C103.601,186.256 103.428,186.431 104.5,185.499Z"
          fill="rgb(0,113,165)"
          fillOpacity={0.15}
        />
        <path
          d="M98.422,163.595C100.064,163.961 100.122,163.866 100.487,165.52C99.399,164.587 99.506,164.692 98.422,163.595Z"
          fill="rgb(0,118,165)"
          fillOpacity={0.16}
        />
        <path
          d="M221.491,162.486C221.13,164.128 221.082,164.047 219.418,164.397C220.503,163.342 220.393,163.446 221.491,162.486Z"
          fill="rgb(0,111,163)"
          fillOpacity={0.15}
        />
        <path
          d="M109.42,171.598C111.072,171.969 111.116,171.892 111.491,173.515C110.412,172.598 110.516,172.703 109.42,171.598Z"
          fill="rgb(0,115,166)"
          fillOpacity={0.16}
        />
        <path
          d="M218.418,112.602C220.096,112.97 220.108,112.93 220.477,114.535C219.791,113.891 219.104,113.246 218.418,112.602Z"
          fill="rgb(0,112,165)"
          fillOpacity={0.16}
        />
        <path
          d="M118.369,100.37L118.174,101.134C117.278,102.018 117.485,102.166 116.418,102.4C116.577,102.241 117.409,101.405 118.369,100.37Z"
          fill="rgb(0,113,162)"
          fillOpacity={0.15}
        />
        <path
          d="M134.383,87.382C133.319,88.937 133.612,89.142 132.424,89.408C133.426,88.422 134.23,87.548 134.383,87.382Z"
          fill="rgb(0,108,159)"
          fillOpacity={0.15}
        />
        <path
          d="M204.619,85.382C205.585,86.408 206.42,87.246 206.579,87.406C205.428,87.149 205.718,86.965 204.619,85.382Z"
          fill="rgb(0,113,163)"
          fillOpacity={0.15}
        />
        <path
          d="M218.611,96.379C218.768,96.542 219.595,97.4 220.583,98.402C219.468,98.152 219.754,97.988 218.611,96.379Z"
          fill="rgb(0,112,163)"
          fillOpacity={0.15}
        />
        <path
          d="M133.575,104.579C132.52,105.663 132.617,105.569 131.503,106.505C131.907,104.907 131.932,104.964 133.575,104.579Z"
          fill="rgb(0,116,167)"
          fillOpacity={0.16}
        />
        <path
          d="M102.397,113.388C101.28,114.952 101.563,115.135 100.414,115.396C101.41,114.405 102.239,113.55 102.397,113.388Z"
          fill="rgb(0,112,162)"
          fillOpacity={0.16}
        />
        <path
          d="M205.57,264.586C205.411,264.745 204.573,265.577 203.619,266.611L203.804,265.84C204.393,265.422 204.982,265.004 205.57,264.586Z"
          fill="rgb(0,111,163)"
          fillOpacity={0.15}
        />
        <path
          d="M99.484,189.475C98.799,190.121 98.115,190.768 97.431,191.414C98.518,190.324 98.412,190.429 99.484,189.475Z"
          fill="rgb(0,117,160)"
          fillOpacity={0.16}
        />
        <path
          d="M123.429,255.584C124.578,255.853 124.298,256.035 125.418,257.589C124.337,256.502 124.476,256.642 123.429,255.584Z"
          fill="rgb(0,114,164)"
          fillOpacity={0.15}
        />
        <path
          d="M128.428,259.586C129.599,259.864 129.316,260.058 130.405,261.602C130.248,261.439 129.424,260.58 128.428,259.586Z"
          fill="rgb(0,113,160)"
          fillOpacity={0.15}
        />
        <path
          d="M154.579,162.583C153.546,163.645 153.64,163.557 152.508,164.512C152.901,162.896 152.937,162.969 154.579,162.583Z"
          fill="rgb(0,116,167)"
          fillOpacity={0.16}
        />
        <path
          d="M232.438,123.568C234.085,123.963 234.106,123.916 234.506,125.493C233.433,124.556 233.536,124.657 232.438,123.568Z"
          fill="rgb(0,114,160)"
          fillOpacity={0.15}
        />
        <path
          d="M204.431,101.573C206.085,101.968 206.101,101.92 206.494,103.509C205.409,102.583 205.51,102.686 204.431,101.573Z"
          fill="rgb(0,114,167)"
          fillOpacity={0.16}
        />
        <path
          d="M118.578,190.597C117.518,191.635 117.61,191.55 116.5,192.5C117.697,191.032 117.438,190.861 118.578,190.597Z"
          fill="rgb(0,114,163)"
          fillOpacity={0.16}
        />
        <path
          d="M237.576,238.592C237.416,238.751 236.578,239.583 235.614,240.613L235.813,239.854C236.4,239.433 236.988,239.012 237.576,238.592Z"
          fill="rgb(0,110,161)"
          fillOpacity={0.16}
        />
        <path
          d="M133.426,263.588C134.593,263.869 134.307,264.061 135.381,265.613C134.422,264.584 133.586,263.747 133.426,263.588Z"
          fill="rgb(0,113,162)"
          fillOpacity={0.16}
        />
        <path
          d="M145.584,169.601C144.493,170.692 144.6,170.586 143.507,171.51C143.902,169.93 143.924,169.982 145.584,169.601Z"
          fill="rgb(0,114,165)"
          fillOpacity={0.16}
        />
        <path
          d="M131.358,164.36L131.178,165.13C130.185,166.078 130.383,166.182 129.423,166.417C129.58,166.255 130.41,165.405 131.358,164.36Z"
          fill="rgb(0,107,161)"
          fillOpacity={0.16}
        />
        <path
          d="M113.521,178.533C113.101,180.082 113.073,180.021 111.416,180.4C112.469,179.367 112.373,179.452 113.521,178.533Z"
          fill="rgb(0,118,164)"
          fillOpacity={0.16}
        />
        <path
          d="M113.414,247.603C114.559,247.863 114.277,248.044 115.398,249.602C114.42,248.587 113.575,247.761 113.414,247.603Z"
          fill="rgb(0,109,161)"
          fillOpacity={0.16}
        />
        <path
          d="M112.573,121.578C111.519,122.65 111.651,122.517 110.578,123.584C111.75,122.001 111.479,121.85 112.573,121.578Z"
          fill="rgb(0,113,163)"
          fillOpacity={0.16}
        />
        <path
          d="M237.481,111.53C238.597,112.437 238.497,112.342 239.58,113.403C237.932,113.01 237.913,113.057 237.481,111.53Z"
          fill="rgb(0,115,165)"
          fillOpacity={0.17}
        />
        <path
          d="M211.405,243.398C210.247,244.996 210.521,245.148 209.428,245.423C209.586,245.261 210.416,244.412 211.405,243.398Z"
          fill="rgb(0,108,162)"
          fillOpacity={0.16}
        />
        <path
          d="M215.376,110.623C216.003,110.687 216.631,110.751 217.259,110.816L217.313,111.828C216.111,111.368 216.234,111.433 215.376,110.623Z"
          fill="rgb(0,164,192)"
          fillOpacity={0.1}
        />
        <path
          d="M126.686,242.177C127.88,242.637 127.757,242.572 128.616,243.386C127.997,243.312 127.378,243.238 126.76,243.164L126.686,242.177Z"
          fill="rgb(0,163,193)"
          fillOpacity={0.11}
        />
        <path
          d="M111.683,230.183C112.856,230.627 112.736,230.559 113.615,231.386L112.804,231.136C112.431,230.818 112.057,230.5 111.683,230.183Z"
          fill="rgb(0,164,193)"
          fillOpacity={0.11}
        />
        <path
          d="M106.676,226.21C107.852,226.641 107.732,226.574 108.601,227.401L107.804,227.144C107.428,226.833 107.052,226.521 106.676,226.21Z"
          fill="rgb(0,162,192)"
          fillOpacity={0.12}
        />
        <path
          d="M141.376,270.632C142.01,270.683 142.644,270.735 143.279,270.786L143.325,271.785C142.675,271.401 142.026,271.016 141.376,270.632Z"
          fill="rgb(0,114,192)"
          fillOpacity={0.09}
        />
        <path
          d="M108.233,109.167C107.294,110.073 107.512,110.234 106.426,110.422C107.198,109.613 107.079,109.674 108.233,109.167Z"
          fill="rgb(0,117,196)"
          fillOpacity={0.13}
        />
        <path
          d="M110.672,157.185C111.831,157.624 111.713,157.553 112.608,158.389C111.533,158.207 111.737,158.071 110.672,157.185Z"
          fill="rgb(0,158,188)"
          fillOpacity={0.13}
        />
        <path
          d="M216.672,95.22C217.318,95.606 217.965,95.993 218.611,96.379C217.553,96.26 217.766,96.115 216.672,95.22Z"
          fill="rgb(0,114,191)"
          fillOpacity={0.1}
        />
        <path
          d="M201.193,252.145C200.264,253.082 200.485,253.233 199.43,253.425C200.183,252.628 200.077,252.68 201.193,252.145Z"
          fill="rgb(0,126,175)"
          fillOpacity={0.14}
        />
        <path
          d="M240.671,114.217C241.314,114.609 241.958,115 242.601,115.392C241.994,115.306 241.387,115.22 240.779,115.133L240.671,114.217Z"
          fill="rgb(0,130,189)"
          fillOpacity={0.11}
        />
        <path
          d="M130.405,261.602C131.471,261.743 131.265,261.887 132.337,262.761C131.693,262.375 131.049,261.989 130.405,261.602Z"
          fill="rgb(0,116,192)"
          fillOpacity={0.11}
        />
        <path
          d="M112.804,231.136L113.615,231.386C113.936,231.73 114.257,232.074 114.577,232.419C113.597,232.232 113.812,232.113 112.804,231.136Z"
          fill="rgb(0,132,176)"
          fillOpacity={0.15}
        />
        <path
          d="M222.789,100.134L223.595,100.397C223.926,100.729 224.258,101.06 224.589,101.391C223.543,101.217 223.763,101.071 222.789,100.134Z"
          fill="rgb(0,126,179)"
          fillOpacity={0.14}
        />
        <path
          d="M108.41,182.402L109.221,182.143C108.226,183.093 108.443,183.225 107.42,183.414C107.75,183.077 108.08,182.739 108.41,182.402Z"
          fill="rgb(0,130,176)"
          fillOpacity={0.15}
        />
        <path
          d="M120.417,253.59C121.472,253.739 121.266,253.878 122.339,254.759C121.699,254.37 121.058,253.98 120.417,253.59Z"
          fill="rgb(0,117,192)"
          fillOpacity={0.11}
        />
        <path
          d="M125.418,257.589C126.484,257.741 126.279,257.883 127.34,258.756C126.7,258.367 126.059,257.978 125.418,257.589Z"
          fill="rgb(0,116,193)"
          fillOpacity={0.11}
        />
        <path
          d="M110.412,245.595C111.408,245.73 111.2,245.851 112.327,246.776C111.689,246.382 111.05,245.988 110.412,245.595Z"
          fill="rgb(0,116,192)"
          fillOpacity={0.11}
        />
        <path
          d="M201.386,177.394L202.238,177.217C201.142,178.152 201.349,178.245 200.421,178.405C200.743,178.068 201.065,177.731 201.386,177.394Z"
          fill="rgb(0,126,179)"
          fillOpacity={0.16}
        />
        <path
          d="M132.778,247.159L133.575,247.419C133.908,247.753 134.24,248.088 134.572,248.422C133.515,248.225 133.73,248.078 132.778,247.159Z"
          fill="rgb(0,125,174)"
          fillOpacity={0.14}
        />
        <path
          d="M114.672,160.191C115.315,160.588 115.958,160.984 116.601,161.38C115.958,160.984 115.315,160.588 114.672,160.191Z"
          fill="rgb(0,156,184)"
          fillOpacity={0.15}
        />
        <path
          d="M196.403,95.602L197.198,95.873C197.574,96.178 197.95,96.483 198.326,96.788C197.685,96.393 197.044,95.997 196.403,95.602Z"
          fill="rgb(0,129,189)"
          fillOpacity={0.12}
        />
        <path
          d="M195.427,94.579C196.424,94.776 196.211,94.902 197.198,95.873L196.403,95.602C196.077,95.261 195.752,94.92 195.427,94.579Z"
          fill="rgb(0,131,175)"
          fillOpacity={0.15}
        />
        <path
          d="M117.566,117.571C116.797,118.382 116.9,118.327 115.803,118.851C116.714,117.941 116.501,117.792 117.566,117.571Z"
          fill="rgb(0,125,173)"
          fillOpacity={0.15}
        />
        <path
          d="M207.664,88.233C208.308,88.621 208.952,89.009 209.596,89.396C208.571,89.248 208.77,89.12 207.664,88.233Z"
          fill="rgb(0,114,189)"
          fillOpacity={0.12}
        />
        <path
          d="M107.804,227.144L108.601,227.401C108.921,227.745 109.242,228.089 109.562,228.433C108.558,228.224 108.772,228.099 107.804,227.144Z"
          fill="rgb(0,121,178)"
          fillOpacity={0.16}
        />
        <path
          d="M192.773,198.86C193.38,198.775 193.988,198.69 194.595,198.604C193.955,198.976 193.314,199.348 192.674,199.719L192.773,198.86Z"
          fill="rgb(0,114,189)"
          fillOpacity={0.12}
        />
        <path
          d="M136.199,161.129C135.269,162.042 135.486,162.194 134.417,162.396C135.194,161.612 135.088,161.67 136.199,161.129Z"
          fill="rgb(0,128,173)"
          fillOpacity={0.15}
        />
        <path
          d="M144.432,79.428L145.226,79.196C144.333,80.052 144.538,80.216 143.438,80.432C143.769,80.098 144.101,79.763 144.432,79.428Z"
          fill="rgb(0,125,174)"
          fillOpacity={0.15}
        />
        <path
          d="M209.422,105.584C210.404,105.785 210.193,105.902 211.201,106.875L210.403,106.603C210.076,106.263 209.749,105.923 209.422,105.584Z"
          fill="rgb(0,125,177)"
          fillOpacity={0.16}
        />
        <path
          d="M225.782,247.87L225.605,248.629C225.278,248.96 224.95,249.292 224.623,249.624L224.821,248.871C225.142,248.537 225.462,248.204 225.782,247.87Z"
          fill="rgb(0,127,182)"
          fillOpacity={0.13}
        />
        <path
          d="M110.335,181.235C109.963,181.538 109.592,181.841 109.221,182.143L108.41,182.402C109.052,182.013 109.693,181.624 110.335,181.235Z"
          fill="rgb(0,114,189)"
          fillOpacity={0.12}
        />
        <path
          d="M210.403,106.603L211.201,106.875C211.577,107.178 211.953,107.481 212.33,107.783C211.687,107.39 211.045,106.996 210.403,106.603Z"
          fill="rgb(0,127,186)"
          fillOpacity={0.13}
        />
        <path
          d="M231.581,243.599C231.252,243.932 230.923,244.264 230.595,244.597L229.825,244.858C230.73,243.956 230.513,243.8 231.581,243.599Z"
          fill="rgb(0,125,178)"
          fillOpacity={0.15}
        />
        <path
          d="M143.573,96.578C142.8,97.363 142.906,97.321 141.783,97.849C142.772,96.909 142.567,96.781 143.573,96.578Z"
          fill="rgb(0,121,178)"
          fillOpacity={0.15}
        />
        <path
          d="M131.665,246.24C132.301,246.633 132.938,247.026 133.575,247.419L132.778,247.159C132.407,246.853 132.036,246.547 131.665,246.24Z"
          fill="rgb(0,116,191)"
          fillOpacity={0.12}
        />
        <path
          d="M121.674,238.217C122.312,238.614 122.95,239.012 123.587,239.409L122.8,239.136C122.425,238.83 122.049,238.523 121.674,238.217Z"
          fill="rgb(0,128,188)"
          fillOpacity={0.13}
        />
        <path
          d="M221.662,99.236C222.306,99.623 222.951,100.01 223.595,100.397L222.789,100.134C222.413,99.835 222.038,99.535 221.662,99.236Z"
          fill="rgb(0,113,188)"
          fillOpacity={0.12}
        />
        <path
          d="M149.565,166.571C148.795,167.36 148.901,167.316 147.782,167.851C148.775,166.9 148.569,166.778 149.565,166.571Z"
          fill="rgb(0,121,177)"
          fillOpacity={0.15}
        />
        <path
          d="M122.8,239.136L123.587,239.409C123.915,239.747 124.243,240.085 124.571,240.424C123.575,240.217 123.784,240.093 122.8,239.136Z"
          fill="rgb(0,121,176)"
          fillOpacity={0.15}
        />
        <path
          d="M119.222,251.87C119.621,252.443 120.019,253.017 120.417,253.59C120.08,253.266 119.744,252.942 119.407,252.617L119.222,251.87Z"
          fill="rgb(0,131,181)"
          fillOpacity={0.14}
        />
        <path
          d="M199.587,269.607C199.252,269.934 198.918,270.261 198.583,270.589L197.809,270.853C198.703,269.979 198.49,269.814 199.587,269.607Z"
          fill="rgb(0,124,176)"
          fillOpacity={0.15}
        />
        <path
          d="M217.217,239.154C216.219,240.098 216.423,240.219 215.43,240.425C216.202,239.64 216.096,239.683 217.217,239.154Z"
          fill="rgb(0,120,176)"
          fillOpacity={0.15}
        />
        <path
          d="M217.471,165.455C217.276,166.366 217.167,166.162 216.189,167.106C216.616,166.556 217.044,166.006 217.471,165.455Z"
          fill="rgb(0,124,183)"
          fillOpacity={0.14}
        />
        <path
          d="M138.581,100.584C137.813,101.377 137.918,101.333 136.794,101.869C137.828,100.895 137.623,100.791 138.581,100.584Z"
          fill="rgb(0,128,178)"
          fillOpacity={0.16}
        />
        <path
          d="M117.788,235.143L118.585,235.409C118.913,235.748 119.24,236.088 119.568,236.427C118.597,236.216 118.802,236.106 117.788,235.143Z"
          fill="rgb(0,124,177)"
          fillOpacity={0.16}
        />
        <path
          d="M148.814,91.873C148.414,92.456 148.015,93.039 147.616,93.622L147.82,92.866C148.151,92.535 148.483,92.204 148.814,91.873Z"
          fill="rgb(0,124,179)"
          fillOpacity={0.15}
        />
        <path
          d="M139.414,83.41C139.018,83.986 138.623,84.562 138.227,85.138L138.415,84.393C138.748,84.066 139.081,83.738 139.414,83.41Z"
          fill="rgb(0,123,181)"
          fillOpacity={0.15}
        />
        <path
          d="M151.665,187.22C152.306,187.614 152.948,188.008 153.59,188.402C152.511,188.19 152.7,188.058 151.665,187.22Z"
          fill="rgb(0,126,185)"
          fillOpacity={0.14}
        />
        <path
          d="M143.426,196.581C144.063,196.978 144.7,197.375 145.337,197.772C144.7,197.375 144.063,196.978 143.426,196.581Z"
          fill="rgb(0,126,186)"
          fillOpacity={0.15}
        />
        <path
          d="M121.658,165.24C122.293,165.637 122.927,166.035 123.561,166.432C122.459,166.2 122.645,166.06 121.658,165.24Z"
          fill="rgb(0,114,188)"
          fillOpacity={0.14}
        />
        <path
          d="M116.662,234.241C117.303,234.63 117.944,235.02 118.585,235.409L117.788,235.143C117.412,234.843 117.037,234.542 116.662,234.241Z"
          fill="rgb(0,113,186)"
          fillOpacity={0.14}
        />
        <path
          d="M147.447,199.559C148.547,199.774 148.278,199.849 149.3,200.678C148.683,200.305 148.065,199.932 147.447,199.559Z"
          fill="rgb(0,117,192)"
          fillOpacity={0.14}
        />
        <path
          d="M106.422,169.585C107.45,169.808 107.263,169.915 108.339,170.775C107.7,170.378 107.061,169.981 106.422,169.585Z"
          fill="rgb(0,125,184)"
          fillOpacity={0.15}
        />
        <path
          d="M146.283,78.331C145.93,78.619 145.578,78.908 145.226,79.196L144.432,79.428C145.049,79.062 145.666,78.696 146.283,78.331Z"
          fill="rgb(0,118,194)"
          fillOpacity={0.12}
        />
        <path
          d="M191.342,185.236C190.295,186.06 190.479,186.183 189.413,186.402C190.056,186.014 190.699,185.625 191.342,185.236Z"
          fill="rgb(0,111,181)"
          fillOpacity={0.15}
        />
        <path
          d="M187.438,163.569C188.073,163.963 188.708,164.358 189.343,164.752C188.708,164.358 188.073,163.963 187.438,163.569Z"
          fill="rgb(0,114,185)"
          fillOpacity={0.16}
        />
        <path
          d="M187.339,188.235C186.304,189.056 186.484,189.175 185.419,189.411C186.059,189.019 186.699,188.627 187.339,188.235Z"
          fill="rgb(0,111,182)"
          fillOpacity={0.16}
        />
        <path
          d="M140.653,179.245C141.291,179.638 141.93,180.03 142.569,180.422C141.93,180.03 141.291,179.638 140.653,179.245Z"
          fill="rgb(0,112,183)"
          fillOpacity={0.17}
        />
        <path
          d="M191.437,166.57C192.072,166.964 192.707,167.359 193.342,167.754C192.707,167.359 192.072,166.964 191.437,166.57Z"
          fill="rgb(0,112,184)"
          fillOpacity={0.16}
        />
        <path
          d="M233.343,154.242C232.706,154.636 232.069,155.03 231.432,155.425C232.069,155.03 232.706,154.636 233.343,154.242Z"
          fill="rgb(0,111,183)"
          fillOpacity={0.16}
        />
        <path
          d="M226.555,174.568C225.97,174.931 225.386,175.294 224.801,175.657C225.386,175.294 225.97,174.931 226.555,174.568Z"
          fill="rgb(0,127,187)"
          fillOpacity={0.2}
        />
        <path
          d="M216.425,185.583C217.064,185.975 217.702,186.367 218.341,186.759C217.702,186.367 217.064,185.975 216.425,185.583Z"
          fill="rgb(0,110,182)"
          fillOpacity={0.16}
        />
        <path
          d="M200.428,98.579C201.065,98.971 201.702,99.363 202.339,99.755C201.702,99.363 201.065,98.971 200.428,98.579Z"
          fill="rgb(0,124,169)"
          fillOpacity={0.16}
        />
        <path
          d="M212.651,167.236C213.516,167.495 214.38,167.754 215.245,168.013C214.38,167.754 213.516,167.495 212.651,167.236Z"
          fill="rgb(0,80,127)"
          fillOpacity={0.13}
        />
        <path
          d="M113.438,174.58C114.101,174.914 114.765,175.248 115.428,175.582C114.765,175.248 114.101,174.914 113.438,174.58Z"
          fill="rgb(0,116,169)"
          fillOpacity={0.21}
        />
      </g>
    </BaseIcon>
  )
})

AlfredoIcon.displayName = "AlfredoIcon"
